<template>
<b-card id="interpretationsEdition">
  <h5> Édition de l'annotation pour la réponse [{{rousselotPhoneticForm}}] </h5>
  <b-tabs content-class="mt-3">
    <b-tab title="Général" active>
      <b-form-group>
        <b-row class="my-1">
          <b-col sm="5"><label>Confidentialité</label></b-col>
          <b-col sm="7">
            <b-form-select :options="confidentialityList" v-model="interpretationToEdit.confidentiality"></b-form-select>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="5"><label>Réponse lémmatisée </label>
          </b-col>
          <b-col sm="7">
            <b-form-input v-model="interpretationToEdit.lemmatizedResponse"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="5"><label>Type</label>
          </b-col>
          <b-col sm="7">
            <b-form-select :options="typesList" v-model="interpretationToEdit.responseType"></b-form-select>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="5"><label>Motif</label>
          </b-col>
          <b-col sm="7">
            <b-form-input v-model="interpretationToEdit.ground"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="5"><label>Motif spécifique</label>
          </b-col>
          <b-col sm="7">
            <b-form-input v-model="interpretationToEdit.specificGround"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="5"><label>Désignant</label>
          </b-col>
          <b-col sm="7">
            <b-form-input v-model="interpretationToEdit.designating"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="5"><label>Commentaire</label>
          </b-col>
          <b-col sm="7">

            <b-button v-b-modal.interpretationCommentModal>Modifier le commentaire</b-button>
            <b-modal hide-footer id="interpretationCommentModal" title="Commentaire d'annotation">
              <editor-comment v-bind:commentToEdit="interpretationToEdit.interpretationComment" v-on:addComment="addInterpretationComment"></editor-comment>
            </b-modal>
          </b-col>
        </b-row>
      </b-form-group>
    </b-tab>
    <b-tab v-for="(lemmas, lemmasIndex) in interpretationToEdit.lemmasList" :title="'Lemme n°' + (lemmasIndex + 1)" :key="lemmasIndex">
      <b-form-group>
        <b-row class="my-1" v-if="lemmasIndex != 0">
          <b-button size="sm" variant="danger" class="float-right" @click="closeLemmaTab(lemmasIndex)">
            Supprimer Lemme
          </b-button>
        </b-row>
        <b-row class="my-1">
          <b-col sm="5"><label>Nature grammaticale</label>
          </b-col>
          <b-col sm="7">
            <b-form-select :options="grammaticalNatureList" v-model="lemmas.grammaticalNature"></b-form-select>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="5"><label>Genre</label>
          </b-col>
          <b-col sm="7">
            <b-form-select :options="genderList" v-model="lemmas.gender"></b-form-select>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="5"><label>Nombre</label>
          </b-col>
          <b-col sm="7">
            <b-form-select :options="numberList" v-model="lemmas.number"></b-form-select>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="5"><label>Commentaire</label>
          </b-col>
          <b-col sm="7">
            <b-button v-b-modal="`lemmaCommentModal` + lemmasIndex" @click="saveIndex(lemmasIndex, null)">Ajouter un commentaire</b-button>
            <b-modal hide-footer :id="`lemmaCommentModal` + lemmasIndex" title="Commentaire de lemme">
              <editor-comment v-bind:commentToEdit="lemmas.lemmaComments" v-on:addComment="addLemmaComment"></editor-comment>
            </b-modal>          </b-col>
        </b-row>
      </b-form-group>
      <br>
      <h5> Étymons du lemme {{lemmasIndex + 1}}</h5>
      <b-tabs pills card vertical>
        <b-tab :title="'Etymon ' + (etymonsIndex + 1)" v-for="(etymons, etymonsIndex) in lemmas.etymonsList" :key="etymonsIndex">
          <b-form-group>
            <b-row class="my-1" v-if="etymonsIndex != 0">
              <b-button size="sm" variant="danger" class="float-right" @click="closeEtymonTab(etymonsIndex, lemmasIndex)">
                Supprimer Étymon
              </b-button>
            </b-row>
            <b-row class="my-1">
              <b-col sm="5"><label> Niveau de confiance</label></b-col>
              <b-col sm="7">
                <b-form-select :options="uncertaintyList" v-model="etymons.uncertainty"></b-form-select>
              </b-col>
            </b-row>
            <b-row class="my-1">
              <b-col sm="5"><label>Étymon FEW</label>
              </b-col>
              <b-col sm="7">
                <b-form-input v-model="etymons.fewEtymon"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="my-1">
              <b-col sm="5"><label>Origine langue</label>
              </b-col>
              <b-col sm="7">
                <b-form-select :options="languageEtymonList" v-model="etymons.fewEtymonLanguage"></b-form-select>
              </b-col>
            </b-row>
            <b-row class="my-1">
              <b-col sm="5"><label> Signifié</label>
              </b-col>
              <b-col sm="7">
                <b-form-input v-model="etymons.fewEtymonSignified"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="my-1">
              <b-col sm="5"><label>Ref. FEW</label>
              </b-col>
              <b-col sm="7">
                <b-form-input v-model="etymons.fewEtymonReference"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="my-1">
              <b-col sm="5"><label>Commentaire étymon</label>
              </b-col>
              <b-col sm="7">
                <b-button v-b-modal="`etymonCommentModal` + lemmasIndex + `_` + etymonsIndex" @click="saveIndex(lemmasIndex, etymonsIndex)">Ajouter un commentaire</b-button>
                <b-modal hide-footer :id="`etymonCommentModal` + lemmasIndex + `_` + etymonsIndex" title="Commentaire d'Étymon">
                  <editor-comment  v-bind:commentToEdit="etymons.etymonComment" v-on:addComment="addEtymonComment"></editor-comment>
                </b-modal>              </b-col>
            </b-row>
          </b-form-group>
        </b-tab>
        <template v-slot:tabs-end>
          <b-nav-item @click.prevent="newEtymonTab(lemmasIndex)" href="#"><b>+</b></b-nav-item>
        </template>
      </b-tabs>
    </b-tab>
    <template v-slot:tabs-end>
      <b-nav-item @click.prevent="newLemmaTab" href="#"><b>+</b></b-nav-item>
    </template>
  </b-tabs>
  <b-card no-body class="mb-1">
    <b-card-header header-tag="header" class="p-1" role="tab">
      <b-button block href="#" v-b-toggle.accordion-2>Gestion de la propagation</b-button>
    </b-card-header>
    <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
      <b-card-body>
        <b-card-text>
          <b-row class="my-1">
            <b-col sm="7">
              Propager aux {{ countOfIdenticalResponses }} réponses identiques
            </b-col>
            <b-col sm="5">
              <b-form-checkbox id="checkbox-2" v-model="propagation" name="checkbox-2" value="oui" unchecked-value="non">
                {{ propagation }}
              </b-form-checkbox>
            </b-col>
          </b-row>
          <br>

          <div :key="index" v-for="(response, index) in interpretationToEdit.associatedResponses">
            <label>
              <input type="checkbox" class="onoffswitch-checkbox" :value="response" v-model="associatedResponsesCheckboxes" id="inline">
              {{response.rousselotPhoneticForm}}
            </label>
          </div>

          <b-row class="my-1">
            <b-col sm="5">
              <label> Indice de Levensthein </label>
            </b-col>
            <b-col sm="7">
              <b-form-input v-model="levenshteinDistance" @change="applyLevenshtein()" type="number" step="1" min="0" max="20"></b-form-input>
            </b-col>
          </b-row>
          <div v-if=" Object.keys(levenshteinList).length === 0">
            Pas de correspondance - augmenter l'indice de levenshtein
          </div>
          <b-form-checkbox-group v-model="levenshteinCheckboxes">
            <b-form-checkbox class="checkboxes" :value="property" v-for="property in Object.keys(levenshteinList)" :key="property">
              {{property}} - (Distance : {{levenshteinList[property][0]}} - Occurrence: {{levenshteinList[property][1]}})
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-card-text>
      </b-card-body>

    </b-collapse>
  </b-card>
  <b-button variant="success" @click="submit(interpretationToEdit)">Enregistrer</b-button>
  <b-button variant="danger" @click="$emit('closeInterpretationEdition')">Annuler</b-button>
</b-card>
</template>

<script>
import { mapGetters } from 'vuex'
import EditorComment from '@components/commons/EditorComment'

export default {
  name: 'InterpretationsEdition',
  components: { EditorComment },
  props: ['interpretationToEdit', 'rousselotPhoneticForm'],
  data() {
    return {
      lemmasIndex: null,
      etymonsIndex: null,
      // valeur de la checkbox de confidentialité
      confidentiality: "confidentielle",
      propagation: "oui",
      levenshteinDistance: 1,
      levenshteinCheckboxes: [],
      associatedResponsesCheckboxes: [],
    }
  },
  computed: {
    ...mapGetters({
      interpretationsList: 'getInterpretationsList',
      currentInventoryEntry: 'getCurrentInventoryEntry',
      currentMap: 'getCurrentMap',
      countOfIdenticalResponses: 'getCountOfIdenticalResponses',
      levenshteinList: 'getLevenshteinList',
      currentUser: 'getCurrentUser',
      // Listes énumérées
      typesList: 'getTypesList',
      grammaticalNatureList: 'getGrammaticalNatureList',
      languageEtymonList: 'getLanguageEtymonList',
      uncertaintyList: 'getUncertaintyList',
      genderList: 'getGenderList',
      numberList: 'getNumberList',
      confidentialityList: 'getConfidentialityList'
    })
  },
  watch: {
    // Surveille et met à jour la liste des réponses phonétiquement proche
    associatedResponsesList() {
      this.applyLevenshtein()
      this.levenshteinList
    }
  },
  mounted() {
    this.loadCheckBoxes()
  },
  methods: {
    // Permet de 'checker' toutes les checboxes par défaut
    loadCheckBoxes() {
      for (let i = 0; i < this.interpretationToEdit.associatedResponses.length; i++) {
        this.associatedResponsesCheckboxes.push(this.interpretationToEdit.associatedResponses[i])
      }
    },
    // Applique la distance de levenshtein indiquée dans l'input dédié
    applyLevenshtein: function() {
      return this.$store.dispatch('findLevenshteinCorrespondance', {
        mapId: this.currentMap,
        rousselotPhoneticForm: this.currentInventoryEntry.rousselotPhoneticForm,
        levenshteinDistance: this.levenshteinDistance,
        author: this.currentUser.username
      })
    },
    submit: function(interpretationToEdit) {
      this.interpretationToEdit.associatedResponses = this.associatedResponsesCheckboxes
      this.interpretationToEdit.levenshteinList = this.levenshteinCheckboxes
      this.interpretationToEdit.rousselotPhoneticForm = this.rousselotPhoneticForm
      this.interpretationToEdit.inventoryEntry = this.currentInventoryEntry.inventoryEntry
      this.interpretationToEdit.mapId = this.currentMap
      this.interpretationToEdit.spreading = this.propagation === "oui" ? "true" : "false"
      this.interpretationToEdit.author = this.currentUser.username
      this.$store.dispatch('editInterpretation', { interpretationToEdit: interpretationToEdit, mapId: this.currentMap })
    },
    // ---------------------------------------------------------------------------------------------
    // GESTION DES COMMENTAIRES
    // ---------------------------------------------------------------------------------------------

    // Permet de sauvegarder l'index du lemme et éventuellement de l'étymon pour
    // la sauvegarde du commentaire associé à un lemme ou à un étymon donné
    saveIndex: function(lemmasIndex, etymonsIndex) {
      this.lemmasIndex = lemmasIndex
      this.etymonsIndex = etymonsIndex
    },
    addInterpretationComment(comment) {
      this.interpretationToEdit.interpretationComment = comment
      this.$bvModal.hide('interpretationCommentModal')
    },
    // Ajout d'un commentaire de lemme
    addLemmaComment: function(comment) {
      this.interpretationToEdit.lemmasList[this.lemmasIndex].lemmaComments = comment
      this.$bvModal.hide('lemmaCommentModal' + this.lemmasIndex)
    },
    // Ajout d'un commentaire d'étymon
    addEtymonComment: function(comment) {
      this.interpretationToEdit.lemmasList[this.lemmasIndex].etymonsList[this.etymonsIndex].etymonComment = comment
      this.$bvModal.hide('etymonCommentModal' + this.lemmasIndex + "_" + this.etymonsIndex)
    },
    // ---------------------------------------------------------------------------------------------
    // GESTION DES ONGLETS (TABS)
    // ---------------------------------------------------------------------------------------------

    // Fonction qui gère l'ajout de lemmes dans le formulaire de création d'interprétation
    newLemmaTab: function() {
      this.interpretationToEdit.lemmasList.push({
        grammaticalNature: '',
        gender: '',
        number: '',
        lemmaComments: '',
        etymonsList: [{
          uncertainty: '',
          fewEtymon: '',
          fewEtymonLanguage: '',
          fewEtymonSignified: '',
          fewEtymonReference: '',
          etymonComment: ''
        }]
      })
    },
    // Fonction qui gère l'ajout d'étymon dans le formulaire de création d'interprétation
    newEtymonTab: function(lemmasIndex) {
      this.interpretationToEdit.lemmasList[lemmasIndex].etymonsList.push({
        uncertainty: '',
        fewEtymon: '',
        fewEtymonLanguage: '',
        fewEtymonSignified: '',
        fewEtymonReference: '',
        etymonComment: ''
      })
    },
    // Fonction qui supprime un lemme dans le formulaire de création d'interprétation
    closeLemmaTab(lemmasIndex) {
      this.interpretationToEdit.lemmasList.splice(lemmasIndex, 1)
    },
    // Fonction qui supprime un étymon dans le formulaire de création d'interprétation
    closeEtymonTab(etymonsIndex, lemmasIndex) {
      this.interpretationToEdit.lemmasList[lemmasIndex].etymonsList.splice(etymonsIndex, 1)
    }
  }
}
</script>
<style>
#interpretationsEdition {
  padding: 15px;
}


.modal-content {
  margin-top: 30%;
  color: black;
  background-color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/sideBarViewer/interpretationsSideBar/InterpretationsEdition.vue